const EXPIRED_COOKIE_DATE = "Thu, 01 Jan 1970 00:00:00 GMT";

export function getAuthCookieOptions(protocol = window.location.protocol) {
  return {
    path: "/",
    sameSite: "lax" as const,
    secure: protocol === "https:",
  };
}

export function buildAuthCookie(
  name: string,
  value: string,
  protocol = window.location.protocol
) {
  const { path, secure } = getAuthCookieOptions(protocol);
  const attributes = [`${name}=${value}`, `path=${path}`, "SameSite=Lax"];
  if (secure) attributes.push("Secure");
  return attributes.join("; ");
}

export function buildExpiredAuthCookie(
  name: string,
  protocol = window.location.protocol
) {
  const clearedCookie = buildAuthCookie(name, "", protocol);
  return `${clearedCookie}; expires=${EXPIRED_COOKIE_DATE}`;
}
